// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__tmSMb","logo":"PageHeader_logo__3cL0W","infoContainer":"PageHeader_infoContainer__Hr_vv"};